import { Types } from './actions';

export const INITIAL_STATE = false;

export default function loading(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case Types.TOGGLE: {
      const { payload } = action;
      return payload;
    }
    default:
      return state;
  }
}
